import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import { postData } from '@/utils/postData';

export const useSetDeliveryCountry = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: postData(Endpoint.SetDeliveryCountry),
    onSuccess: data => {
      if (data.isSuccess) {
        queryClient.invalidateQueries({ queryKey: [QueryKey.GetCart] });
      }
    },
  });

  return { setDeliveryCountry: mutate };
};
